import React, {ComponentType, FC} from 'react';
import {Redirect, RouteProps, Route} from 'react-router-dom';

import {URL_AUTH_ROUTER} from 'shared/constants/urls';
import {useAppSelector} from 'store/config/hooks';
import {selectIsAuthenticated} from 'store/slices/auth-slice';

interface IProtectedRouteProps extends RouteProps {
    component: ComponentType<any>;
}

export const ProtectedRoute: FC<IProtectedRouteProps> = ({
    component: Component,
    ...props
}: IProtectedRouteProps) => {
    const isAuthorized = useAppSelector(selectIsAuthenticated);

    return (
        <Route
            {...props}
            render={componentProps => (isAuthorized
                ? <Component {...componentProps} />
                : <Redirect to={URL_AUTH_ROUTER} />)}
        />
    );
};
